import {Injectable, inject} from '@angular/core';
import {ToastService, type ToastVariant} from '@sms-ir/ui-components';

@Injectable({
  providedIn: 'root',
})
export class ToastifyService {
  private readonly toast = inject(ToastService);

  success(message: string, title?: string): void {
    this.show('success', message, title);
  }

  error(message: string, title?: string): void {
    this.show('error', message, title);
  }

  warning(message: string, title?: string): void {
    this.show('warning', message, title);
  }

  info(message: string, title?: string): void {
    this.show('info', message, title);
  }

  private show(variant: ToastVariant, message: string, title?: string): void {
    const hasTitle = !!title?.trim();

    this.toast.add({
      variant,
      message: hasTitle ? String(title).trim() : message,
      description: hasTitle ? message : undefined,
      icon: true,
      dismissible: true,
    });
  }
}
